import React from 'react';
import { 
  Box, 
  Typography, 
  Grid, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  useTheme
} from '@mui/material';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import { Categories } from '../constants/menu-items';
import { ManualItem } from '../types';

interface DocumentsGuidesProps {
  manualItems: ManualItem[];
}

const DocumentsGuides: React.FC<DocumentsGuidesProps> = ({ manualItems }) => {
  const theme = useTheme();

  const getItemsByCategory = (category: string) => {
    return manualItems
      .filter(item => item.locations?.documents?.category === category)
      .map(item => ({
        name: item.name,
        url: item.type === 'file' ? item.fileUrl : item.externalUrl
      }));
  };


  return (
    <Box sx={{ 
      py: 6,
      px: { xs: 2, md: 8 },
      backgroundColor: '#ffffff'
    }}>
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant="overline" 
          component="div" 
          sx={{
            color: 'orange',
            fontWeight: 'bold',
            fontSize: '0.9rem',
            mb: 1,
            display: 'block'
          }}
        >
          DOCUMENTOS Y GUIAS
        </Typography>
        <Typography 
          variant="h4" 
          component="h2"
          sx={{
            fontWeight: 'bold',
            color: theme.palette.text.primary,
            mb: 2
          }}
        >
          Dale un buen uso a tu S10 ERP
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {Categories.map((category, index) => (
          <Grid item xs={12} md={4} key={index}>
            <Box sx={{
              height: '100%',
            //   display: 'flex',
              flexDirection: 'column'
            }}>
              <Typography 
                variant="h5" 
                component="h3"
                sx={{
                  fontWeight: 'bold',
                  color: theme.palette.text.primary,
                  mb: 2
                }}
              >
                {category.title}
              </Typography>
              
              <List dense sx={{ flexGrow: 1 }}>
                {getItemsByCategory(category.title).map((item, itemIndex) => (
                  <ListItem key={itemIndex} sx={{ px: 0 }}>
                    <ListItemIcon sx={{ minWidth: '36px' }}>
                      <ArticleOutlinedIcon  fontSize="small" />
                    </ListItemIcon>
                    <ListItemText 
                      primary={item.name} 
                      sx={{
                        '& .MuiTypography-root': {
                          color: theme.palette.text.secondary
                        }
                      }}
                    />
                  </ListItem>
                ))}
                  {/* <ListItem sx={{ px: 0 }}>
                    <Button 
                        sx={{
                        alignSelf: 'flex-start',
                        textTransform: 'none',
                        color: theme.palette.primary.main,
                        fontWeight: 'bold',
                        mt: 1
                        }}
                    >
                        Ver todo →
                    </Button>

                  </ListItem> */}
              </List>
              
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default DocumentsGuides;